// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-progress-track {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 10001; /* above the sticky header (1000) and the demo widget (9999/10000) */
  background: transparent;
  pointer-events: none;
}
.scroll-progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #3B6B94 0%, #6CE5E8 100%);
  box-shadow: 0 0 8px rgba(108, 229, 232, 0.6);
  transition: width 0.12s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .scroll-progress-fill { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/scrollprogress.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,cAAc,EAAE,oEAAoE;EACpF,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,4DAA4D;EAC5D,4CAA4C;EAC5C,gCAAgC;AAClC;AACA;EACE,wBAAwB,gBAAgB,EAAE;AAC5C","sourcesContent":[".scroll-progress-track {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  z-index: 10001; /* above the sticky header (1000) and the demo widget (9999/10000) */\n  background: transparent;\n  pointer-events: none;\n}\n.scroll-progress-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #3B6B94 0%, #6CE5E8 100%);\n  box-shadow: 0 0 8px rgba(108, 229, 232, 0.6);\n  transition: width 0.12s ease-out;\n}\n@media (prefers-reduced-motion: reduce) {\n  .scroll-progress-fill { transition: none; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
